import { FC } from 'react'
import { FormItem, GroupedResidentsMultiSelect } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { reportingTranslations } from 'locale/reporting'
import { FormInstance, Select } from 'antd'
import { Home } from '@lmc/ts-common'
import { useSelector } from 'react-redux'
import useResidentsList from 'hooks/useResidentsList'

type Props = {
  preferredPeopleNominative: string
  form?: FormInstance<any>
  isGroupDownload?: boolean
}

export const ServiceUserExportForm: FC<Props> = ({
  preferredPeopleNominative,
  form,
  isGroupDownload,
}) => {
  const { t } = useTranslation(NAMESPACE.REPORTING)

  const { residents } = useResidentsList({})

  const homes = useSelector(
    (state: { data: { homes: Home[] } }) => state.data.homes
  )

  const homeOptions = homes.map((home) => ({
    value: home?.id,
    label: home?.name,
  }))

  return (
    <>
      <FormItem
        label={preferredPeopleNominative}
        name="residents"
        extra={t(reportingTranslations.SELECT_ENTITY, {
          variable: preferredPeopleNominative,
        })}
      >
        <GroupedResidentsMultiSelect
          residents={residents}
          title={preferredPeopleNominative || ''}
          handleInputChange={(values) =>
            form?.setFieldValue('residents', values)
          }
          placeholder={false}
        />
      </FormItem>
      {isGroupDownload && (
        <FormItem
          label={t(reportingTranslations.SITES)}
          name="sites"
          extra={t(reportingTranslations.SITES_EXTRA)}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select options={homeOptions} mode="multiple" />
        </FormItem>
      )}
    </>
  )
}
